import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import compose from 'recompose/compose'
import { makeStyles } from '@material-ui/core/styles'
import { history } from '../../../_state/helpers'
import ClassroomSidebar from './Components/ClassroomSidebar'
import CourseStatisticsTabBar, { CourseStatisticsTab } from '../../../Components/CourseStatistics/CourseStatisticsTabBar'
import CourseStatisticsContent from '../../../Components/CourseStatistics/CourseStatisticsContent'

const useStyles = makeStyles(() => ({
    root: {
        minHeight: '300px',
        marginLeft: 'calc(15% + 25px)',
        marginRight: '25px',
        paddingBottom: '60px',
    },
}))

/**
 * Classroom scoped course statistics. Same body as the organization page, scoped to one classroom,
 * which is where teachers have the most use for "who is struggling in this course".
 */
const ClassroomCourseStatistics = (props) => {
    const classes = useStyles()

    const { computedMatch, organization } = props
    const classroomId = computedMatch?.params?.classroomId

    const handleTabChange = (tab) => {
        if (tab === CourseStatisticsTab.Overview) {
            history.push(`/dashboard/classroom/${classroomId}/statistics`)
        }
    }

    return (
        <div className={classes.root}>
            <ClassroomSidebar userGroupId={classroomId} path={computedMatch?.path} />
            <CourseStatisticsTabBar activeTab={CourseStatisticsTab.Courses} onChange={handleTabChange} />
            <CourseStatisticsContent
                organizationId={organization.selectedOrganization}
                userGroupId={classroomId}
            />
        </div>
    )
}

function mapStateToProps(state) {
    const { organization, user, usergroup } = state
    return {
        organization,
        user,
        usergroup,
    }
}

export default compose(withRouter, connect(mapStateToProps))(ClassroomCourseStatistics)
